import React from "react";
import { observer, inject } from "mobx-react";
import paginator from "@components/Pagination/paginator";
import axios from "axios";

@inject("store")
@observer

export default class CustomerOrderHistory extends React.Component {


    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
        this.changePage = this.changePage.bind(this);
        this.buildPagination = this.buildPagination.bind(this);
        this.getDocumentUrl = this.getDocumentUrl.bind(this);
        this.state = { orderHeads: null, columnDataTypes: [], totalfound: 0, itemsperpage: 50, currentpage: 1 };

    }


    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentpage !== this.state.currentpage) {
            console.log("didupdate", prevState.currentpage, this.state.currentpage);
            this.update();
        }
    }


    componentWillUnmount() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to component unmount.');

        }
    }

    update() {

        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
            //console.log("reuest cancelled");
        }

        this._source = axios.CancelToken.source();
        this.props.store.reports.getOrderHistory(this.state.currentpage, this._source.token).then(
            result => {
                this.setState({
                    rows: result.data.Rows,
                    columnDataTypes: result.columns,
                    totalfound: result.totalfound,
                    itemsperpage: result.itemsperpage,
                    currentpage: result.currentpage
                });
            },
            error => {
                if (!axios.isCancel(error)) {
                    alert("an error occured");
                }
            });
    }

    changePage(e, page) {
        console.log("Changepage", page);
        e.preventDefault();
        this.setState({ currentpage: page });
    }

    formatDate(date) {
        if (date === null) {
            return "";
        }
        return new Intl.DateTimeFormat('en-GB',
            {
                //year: 'numeric', 
                //month: 'long', 
                //day: '2-digit' 

            }).format(Date.parse(date));
    }

    formatNumber() { }


    formatMoney(value) {
        return value.toFixed(2);
        //return new Intl.NumberFormat('en-GB',
        //	{
        //		style: 'currency',
        //		//currency: 'GBP',
        //		minimumFractionDigits: 0,
        //		maximumFractionDigits: 0
        //	}).format(value);
    }

    setupColumns(row0, columnsDataType) {
        let config = [];
        const columns = Object.keys(row0);
        // [column: { name:"", classes:"" }]
        config = columns.map((fieldName, index) => {
            const dataType = columnsDataType[fieldName];
            let classes = [];

            switch (dataType) {
                case "Decimal":
                    classes.push("text-right");
                    break;
            }

            switch (fieldName) {
                case "OrderNumber":
                    classes.push("text-medium");
                    break;
                case "TotalSum":
                    break;
                default:
                    classes.push("ellips");
                //classNames = [];
            }
            const classNames = classes.join(" ");

            return { name: fieldName, dataType: dataType, classNames: classNames }
        });

        console.log("columns", config);

        return config;
    }




    formatField(value, dataType) {
        switch (dataType) {

            case "DateTime":
                return this.formatDate(value);

            case "Decimal":
                return this.formatMoney(value);
            default:
                return value;
        }
    }


    buildPagination() {


        const paginationInfo = new paginator(
            this.state.itemsperpage,
            7
        ).build(this.state.totalfound, this.state.currentpage);
        console.log("pagination", paginationInfo);
        const pages = [];
        for (
            let i = paginationInfo.first_page;
            i <= paginationInfo.last_page;
            i++
        ) {
            pages.push(
                <li
                    key={i + ""}
                    className={i === paginationInfo.current_page ? "active" : ""}
                >
                    <a href="#"
                        onClick={(e) => { this.changePage(e, i); }}
                    >{i + ""}</a>
                </li>
            );
        }


        return (
            <nav className="pagination">
                <div className="column">
                    <ul className="pages">
                        {1 !== paginationInfo.current_page && paginationInfo.first_page > 1
                            ? <React.Fragment>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, 1);
                                }}>1</a></li>
                                <li>...</li>
                            </React.Fragment>
                            : null}
                        {pages}
                        {paginationInfo.total_pages !== paginationInfo.current_page &&
                            paginationInfo.last_page < paginationInfo.total_pages
                            ? <React.Fragment>
                                <li>...</li>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, paginationInfo.total_pages);
                                }}>{paginationInfo.total_pages}</a></li>

                            </React.Fragment>
                            : null}


                    </ul>
                </div>

            </nav>);
    }



    getDocumentUrl(e, orderGuid) {
        e.preventDefault();
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
            //console.log("reuest cancelled");
        }

        this._source = axios.CancelToken.source();
        this.props.store.reports.getOrderDocumentUrl("OrderCopy", orderGuid, this._source.token).then(result => {
            var win = window.open(result.url, '_blank');
            win.focus();
        });
    }



    render() {

        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer choosen customer</div>;
        }

        if (!this.state.rows) {
            return <div>Loading...</div>;
        }

        if (this.state.rows.length === 0) {
            return <div><strong>No rows found!</strong></div>;
        }

        const columns = this.setupColumns(this.state.rows[0], this.state.columnDataTypes);
        const pagination = this.buildPagination();
        const tree = this.props.tree;


        return (
            <div style={{ minHeight: 500, width: "100%" }}
            >
                {pagination}
                <div className="row">
                    <div className="col-12">
                        <strong>Orders</strong>
                        <hr />
                    </div>
                </div>
                {this.state.rows.map(row => {
                    return (
                        <div
                            key={row["OrderNr"]}
                            className="row"

                        >
                            <div className="col-12">
                                {row["DocumentExists"] ? <a href={"/Umbraco/Api/MyPages/OrderHistoryDocument?cid=" + this.props.store.navigation.getCustomerId() + "&DocumentId=" + row["OrderNr"]}>
                                    <strong>{row["OrderNr"]}</strong>
                                </a> :  <strong>{row["OrderNr"]}</strong>}
                                <span className="float-right">{row["TotalSum"]} {row["Currency"]}</span><br />
                                <div className="text-xxs">
                                    <strong>Registered:</strong> {row["RegistrationDate"]}<br/><strong>Status:</strong> {row["OrderStatus"]}
                                </div>
                                <hr />
                            </div>
                        </div>
                    );

                })}
                {pagination}
            </div>);

    }
}